function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#717375",
  d: "M81.8,87.7h-3.5v-9c0-13.6-8-19.8-13.3-24c-2.3-1.8-4.5-3.5-4.5-4.7s2.2-2.9,4.5-4.7 c5.3-4.2,13.3-10.5,13.3-24v-9h3.5c1.4,0,2.5-1.1,2.5-2.5s-1.1-2.5-2.5-2.5h-6H24h-5.8c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5h3.3 v9c0,13.6,8,19.8,13.3,24c2.3,1.8,4.5,3.5,4.5,4.7s-2.2,2.9-4.5,4.7c-5.3,4.2-13.3,10.5-13.3,24v9h-3.3c-1.4,0-2.5,1.1-2.5,2.5 s1.1,2.5,2.5,2.5H24h51.8h6c1.4,0,2.5-1.1,2.5-2.5S83.2,87.7,81.8,87.7z M26.5,87.7v-9c0-11.1,6.3-16.1,11.4-20.1 c3.4-2.7,6.4-5,6.4-8.6c0-3.6-2.9-5.9-6.4-8.6c-5.1-4-11.4-9-11.4-20.1v-9h46.8v9c0,11.1-6.3,16.1-11.4,20.1 c-3.4,2.7-6.4,5-6.4,8.6c0,3.6,2.9,5.9,6.4,8.6c5.1,4,11.4,9,11.4,20.1v9H26.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#717375",
  d: "M67.8,21.3v-3.5h-9.7h-8.2h-8.2H32v3.5c0,8.5,4.5,12,9.3,15.8c2.6,2,5.7,4.4,7.4,7.7c0.5,1,2,1,2.5,0 c1.7-3.3,4.8-5.7,7.4-7.7C63.3,33.3,67.8,29.7,67.8,21.3z"
}));

function SvgTemporary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "temporary_svg__temporary_svg__Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default SvgTemporary;